export type PreviewCamera = { zoom: number; x: number; y: number };
export const MIN_PREVIEW_ZOOM = 0.1;
export const MAX_PREVIEW_ZOOM = 30;
export const fittedCamera: PreviewCamera = { zoom: 1, x: 0, y: 0 };

/** Zoom factors are relative to the fitted image, not the source pixel size. */
export function clampPreviewZoom(zoom: number) {
  return Math.max(MIN_PREVIEW_ZOOM, Math.min(MAX_PREVIEW_ZOOM, zoom));
}

export function fitPreviewSize(imageWidth: number, imageHeight: number, width: number, height: number) {
  const scale = Math.min(Math.max(1, width - 48) / imageWidth, Math.max(1, height - 48) / imageHeight);
  return { width: imageWidth * scale, height: imageHeight * scale };
}

/** Anchor is in CSS pixels relative to the viewport center. */
export function zoomPreviewAt(camera: PreviewCamera, zoom: number, anchor = { x: 0, y: 0 }): PreviewCamera {
  if (!Number.isFinite(zoom)) return camera;
  const nextZoom = clampPreviewZoom(zoom);
  const ratio = nextZoom / camera.zoom;
  return { zoom: nextZoom, x: anchor.x - (anchor.x - camera.x) * ratio, y: anchor.y - (anchor.y - camera.y) * ratio };
}

export function wheelPreviewZoom(camera: PreviewCamera, deltaY: number, deltaMode: number, viewportHeight: number, anchor: { x: number; y: number }) {
  const pixels = deltaY * (deltaMode === 1 ? 16 : deltaMode === 2 ? viewportHeight : 1);
  return zoomPreviewAt(camera, camera.zoom * Math.exp(-Math.max(-240, Math.min(240, pixels)) * 0.002), anchor);
}
